/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import Tooltip from '../common/Tooltip';

const propTypes = {
    settingsData: PropTypes.object.isRequired,
    onSettingChange: PropTypes.func.isRequired,
};

class OperationSettings extends Component {
    render() {
        const { onSettingChange, settingsData } = this.props;

        return (
            <div className="system-settings-section">
                <div className="system-settings-section__header">
                    <div className="system-settings-section__title">
                        Operation Settings
                    </div>
                </div>
                <div className="system-settings-section__content">
                    <div className="system-settings-section__subtitle">
                        Backups
                    </div>
                    <table className="table-settings">
                        <tbody>
                            <tr>
                                <td>
                                    <span>Enable backups</span>
                                    <span className="table-settings__tooltip">
                                        <Tooltip tooltip="Automatically try to overbook jobs with extra standby positions to reduce risk of unfulfilment. Rules are defined below and this can be overridden for each client or job.">
                                            <i className="icon icon-infomation-circle" />
                                        </Tooltip>
                                    </span>
                                </td>
                                <td>
                                    <label className="settings-checkbox">
                                        <input
                                            type="checkbox"
                                            checked={
                                                settingsData.BACKUPS_ENABLED
                                            }
                                            onChange={event => {
                                                onSettingChange({
                                                    BACKUPS_ENABLED:
                                                        event.target.checked,
                                                });
                                            }}
                                        />
                                        <div className="settings-checkbox__container">
                                            <div className="settings-checkbox__indicator" />
                                            <span className="settings-checkbox__yes-label">
                                                Yes
                                            </span>
                                            <span className="settings-checkbox__no-label">
                                                No
                                            </span>
                                        </div>
                                    </label>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span>Backups ratio for new clients</span>
                                    <span className="table-settings__tooltip">
                                        <Tooltip tooltip="How many workers are necessary for one backup position to be opened when new clients post their first booking">
                                            <i className="icon icon-infomation-circle" />
                                        </Tooltip>
                                    </span>
                                </td>
                                <td>
                                    <input
                                        type="number"
                                        min={1}
                                        className="duration"
                                        defaultValue={
                                            settingsData.BACKUPS_PER_FREELANCER_FOR_NEW_CLIENTS
                                        }
                                        onBlur={event => {
                                            onSettingChange({
                                                BACKUPS_PER_FREELANCER_FOR_NEW_CLIENTS:
                                                    event.target.value,
                                            });
                                        }}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span>Backups ratio for all clients</span>
                                    <span className="table-settings__tooltip">
                                        <Tooltip tooltip="How many workers are necessary for one backup position to be opened for all other bookings">
                                            <i className="icon icon-infomation-circle" />
                                        </Tooltip>
                                    </span>
                                </td>
                                <td>
                                    <input
                                        type="number"
                                        min={1}
                                        className="duration"
                                        defaultValue={
                                            settingsData.BACKUPS_PER_FREELANCER_FOR_ALL_CLIENTS
                                        }
                                        onBlur={event => {
                                            onSettingChange({
                                                BACKUPS_PER_FREELANCER_FOR_ALL_CLIENTS:
                                                    event.target.value,
                                            });
                                        }}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span>Backups for unreliable workers</span>
                                    <span className="table-settings__tooltip">
                                        <Tooltip tooltip="Automatically open backups for positions filled with new workers or workers with low punctuality">
                                            <i className="icon icon-infomation-circle" />
                                        </Tooltip>
                                    </span>
                                </td>
                                <td>
                                    <label className="settings-checkbox">
                                        <input
                                            type="checkbox"
                                            checked={
                                                settingsData.BACKUPS_REQUIRED_FOR_NEW_APPLICANTS
                                            }
                                            onChange={event => {
                                                onSettingChange({
                                                    BACKUPS_REQUIRED_FOR_NEW_APPLICANTS:
                                                        event.target.checked,
                                                });
                                            }}
                                        />
                                        <div className="settings-checkbox__container">
                                            <div className="settings-checkbox__indicator" />
                                            <span className="settings-checkbox__yes-label">
                                                Yes
                                            </span>
                                            <span className="settings-checkbox__no-label">
                                                No
                                            </span>
                                        </div>
                                    </label>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span>Backups opening window start</span>
                                    <span className="table-settings__tooltip">
                                        <Tooltip tooltip="Duration before job start after which backups positions are automatically opened">
                                            <i className="icon icon-infomation-circle" />
                                        </Tooltip>
                                    </span>
                                </td>
                                <td>
                                    <input
                                        className="duration"
                                        defaultValue={
                                            settingsData.BACKUPS_OPEN_BEFORE_START
                                        }
                                        onBlur={event => {
                                            onSettingChange({
                                                BACKUPS_OPEN_BEFORE_START:
                                                    event.target.value,
                                            });
                                        }}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span>Backups opening window end</span>
                                    <span className="table-settings__tooltip">
                                        <Tooltip tooltip="Duration before job start after which backups positions are no longer opened">
                                            <i className="icon icon-infomation-circle" />
                                        </Tooltip>
                                    </span>
                                </td>
                                <td>
                                    <input
                                        className="duration"
                                        defaultValue={
                                            settingsData.BACKUPS_CLOSE_BEFORE_START
                                        }
                                        onBlur={event => {
                                            onSettingChange({
                                                BACKUPS_CLOSE_BEFORE_START:
                                                    event.target.value,
                                            });
                                        }}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span>Backups expiration</span>
                                    <span className="table-settings__tooltip">
                                        <Tooltip tooltip="Duration before jobs start after which a standby worker is informed they are no longer required">
                                            <i className="icon icon-infomation-circle" />
                                        </Tooltip>
                                    </span>
                                </td>
                                <td>
                                    <input
                                        className="duration"
                                        defaultValue={
                                            settingsData.BACKUPS_CANCEL_AFTER_START
                                        }
                                        onBlur={event => {
                                            onSettingChange({
                                                BACKUPS_CANCEL_AFTER_START:
                                                    event.target.value,
                                            });
                                        }}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span>Backup worker rate increment</span>
                                    <span className="table-settings__tooltip">
                                        <Tooltip tooltip="How many GBP per hour will be added to invitations for standby jobs">
                                            <i className="icon icon-infomation-circle" />
                                        </Tooltip>
                                    </span>
                                </td>
                                <td>
                                    <input
                                        type="number"
                                        min={0}
                                        step={0.25}
                                        className="duration"
                                        defaultValue={settingsData.BACKUPS_FREELANCER_RATE_INCREASE_GBP.toFixed(
                                            2,
                                        )}
                                        onBlur={event => {
                                            onSettingChange({
                                                BACKUPS_FREELANCER_RATE_INCREASE_GBP:
                                                    event.target.value,
                                            });
                                        }}
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div className="system-settings-section__subtitle margin-top-10">
                        Location tracking
                    </div>
                    <table className="table-settings">
                        <tbody>
                            <tr>
                                <td>
                                    <span>Location tracking start</span>
                                    <span className="table-settings__tooltip">
                                        <Tooltip tooltip="When a worker starts to be tracked via GPS before job starts">
                                            <i className="icon icon-infomation-circle" />
                                        </Tooltip>
                                    </span>
                                </td>
                                <td>
                                    <input
                                        className="duration"
                                        defaultValue={
                                            settingsData.START_BOOKING_LOCATION_TRACKING
                                        }
                                        onBlur={event => {
                                            onSettingChange({
                                                START_BOOKING_LOCATION_TRACKING:
                                                    event.target.value,
                                            });
                                        }}
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <table className="table-settings">
                        <tbody>
                            <tr>
                                <td>
                                    <span>Automatic tracking actions</span>
                                    <span className="table-settings__tooltip">
                                        <Tooltip tooltip="Enable automatic actions for workers that cannot be tracked properly, which includes a set of notifications reminders, texts, and ultimately replacement by a backups or an emergency open positions. This can be overridden for each job if enabled.">
                                            <i className="icon icon-infomation-circle" />
                                        </Tooltip>
                                    </span>
                                </td>
                                <td>
                                    <label className="settings-checkbox">
                                        <input
                                            type="checkbox"
                                            checked={
                                                settingsData.TRACKING_AUTOMATIC_ACTIONS_ENABLED
                                            }
                                            onChange={event => {
                                                onSettingChange({
                                                    TRACKING_AUTOMATIC_ACTIONS_ENABLED:
                                                        event.target.checked,
                                                });
                                            }}
                                        />
                                        <div className="settings-checkbox__container">
                                            <div className="settings-checkbox__indicator" />
                                            <span className="settings-checkbox__yes-label">
                                                Yes
                                            </span>
                                            <span className="settings-checkbox__no-label">
                                                No
                                            </span>
                                        </div>
                                    </label>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span>
                                        Automatic tracking actions start
                                    </span>
                                    <span className="table-settings__tooltip">
                                        <Tooltip tooltip="Duration before job start when automatic actions are triggered if worker is not properly tracked. It starts with a notification prompt, then another notification prompt and a text 15 min later, then attempt to replace the worker 15 min later">
                                            <i className="icon icon-infomation-circle" />
                                        </Tooltip>
                                    </span>
                                </td>
                                <td>
                                    <input
                                        className="duration"
                                        defaultValue={
                                            settingsData.TRACKING_AUTOMATIC_ACTIONS_START
                                        }
                                        onBlur={event => {
                                            onSettingChange({
                                                TRACKING_AUTOMATIC_ACTIONS_START:
                                                    event.target.value,
                                            });
                                        }}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span>
                                        Emergency jobs worker rate increment
                                    </span>
                                    <span className="table-settings__tooltip">
                                        <Tooltip tooltip="How many GBP per hour will be added to invitations for emergency jobs that need to be filled straight away due to last-minute replacement">
                                            <i className="icon icon-infomation-circle" />
                                        </Tooltip>
                                    </span>
                                </td>
                                <td>
                                    <input
                                        type="number"
                                        min={0}
                                        step={0.25}
                                        className="duration"
                                        defaultValue={settingsData.EMERGENCY_FREELANCER_RATE_INCREASE_GBP.toFixed(
                                            2,
                                        )}
                                        onBlur={event => {
                                            onSettingChange({
                                                EMERGENCY_FREELANCER_RATE_INCREASE_GBP:
                                                    event.target.value,
                                            });
                                        }}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span>Emergency jobs start time</span>
                                    <span className="table-settings__tooltip">
                                        <Tooltip tooltip="How much time will be added to invitation start for emergency jobs, so workers are presented with a manageable invitations even if job has actually started">
                                            <i className="icon icon-infomation-circle" />
                                        </Tooltip>
                                    </span>
                                </td>
                                <td>
                                    <input
                                        className="duration"
                                        defaultValue={
                                            settingsData.EMERGENCY_JOB_START_TIME_INCREASE
                                        }
                                        onBlur={event => {
                                            onSettingChange({
                                                EMERGENCY_JOB_START_TIME_INCREASE:
                                                    event.target.value,
                                            });
                                        }}
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div className="system-settings-section__subtitle margin-top-10">
                        Clock-in & Clock-out
                    </div>
                    <table className="table-settings">
                        <tbody>
                            <tr>
                                <td>
                                    <span>Departure confirmation window</span>
                                    <span className="table-settings__tooltip">
                                        <Tooltip tooltip="How much time before start workers are prompted and can confirm they are on their way">
                                            <i className="icon icon-infomation-circle" />
                                        </Tooltip>
                                    </span>
                                </td>
                                <td>
                                    <input
                                        className="duration"
                                        defaultValue={
                                            settingsData.DEPARTURE_CONFIRMATION_TIME
                                        }
                                        onBlur={event => {
                                            onSettingChange({
                                                DEPARTURE_CONFIRMATION_TIME:
                                                    event.target.value,
                                            });
                                        }}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span>Clock-in window start</span>
                                    <span className="table-settings__tooltip">
                                        <Tooltip tooltip="How much time before start workers can clock-in">
                                            <i className="icon icon-infomation-circle" />
                                        </Tooltip>
                                    </span>
                                </td>
                                <td>
                                    <input
                                        className="duration"
                                        defaultValue={
                                            settingsData.CLOCK_IN_EARLY_LIMIT
                                        }
                                        onBlur={event => {
                                            onSettingChange({
                                                CLOCK_IN_EARLY_LIMIT:
                                                    event.target.value,
                                            });
                                        }}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span>Clock-out window end</span>
                                    <span className="table-settings__tooltip">
                                        <Tooltip tooltip="How much time after job end workers can clock-out. After that period they will be automatically clocked-out (in case they forget)">
                                            <i className="icon icon-infomation-circle" />
                                        </Tooltip>
                                    </span>
                                </td>
                                <td>
                                    <input
                                        className="duration"
                                        defaultValue={
                                            settingsData.CLOCK_OUT_MAX_LIMIT
                                        }
                                        onBlur={event => {
                                            onSettingChange({
                                                CLOCK_OUT_MAX_LIMIT:
                                                    event.target.value,
                                            });
                                        }}
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

OperationSettings.propTypes = propTypes;

export default OperationSettings;
